var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 34.0777 33.4971",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 23C13.6863 23 11 20.3137 11 17C11 13.6863 13.6863 11 17 11C20.3137 11 23 13.6863 23 17C23 20.3137 20.3137 23 17 23Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37623 19.0496C3.63748 19.3562 2.44566 21.0358 3.11311 22.6704C4.04495 24.9524 5.53158 26.9856 7.45889 28.5744C10.2148 30.8461 13.6908 32.06 17.2618 31.9977C20.8328 31.9354 24.2644 30.6009 26.9394 28.2343C28.81 26.5793 30.2248 24.4954 31.0765 22.1823C31.6865 20.5254 30.4367 18.8884 28.6883 18.6427C26.94 18.397 25.3702 19.6696 24.5066 21.2096C24.0385 22.0443 23.4308 22.8016 22.7028 23.4457C21.168 24.8036 19.1991 25.5692 17.1503 25.605C15.1014 25.6407 13.107 24.9443 11.5258 23.6408C10.7757 23.0225 10.142 22.2869 9.64502 21.469C8.72823 19.9601 7.11498 18.743 5.37623 19.0496Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.884 18.8745C31.9606 18.2604 32 17.6348 32 17C32 8.71573 25.2843 2 17 2C8.71573 2 2 8.71573 2 17C2 17.8147 2.06495 18.6142 2.18996 19.3937C2.87894 18.4505 3.95426 17.7772 5.11576 17.5724C6.37245 17.3508 7.51458 17.6556 8.48027 18.2253C8.42322 17.8251 8.3937 17.416 8.3937 17C8.3937 12.2469 12.2469 8.3937 17 8.3937C21.7531 8.3937 25.6063 12.2469 25.6063 17C25.6063 17.3134 25.5895 17.6229 25.5569 17.9276C26.5022 17.3243 27.6332 16.9796 28.8971 17.1573C30.0647 17.3214 31.1625 17.9564 31.884 18.8745Z",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eae6050974997b314231904428587d1f.svg";
export { ForwardRef as ReactComponent };